import SuggestedPosts from './SuggestedPosts';
export default SuggestedPosts;
